import { BasePage as CngBasePage } from 'cng-web-lib'
import ManagePreferredCarrierTable from './ManagePreferredCarrierTable.js'
import React from 'react'
import TranslationText from 'src/views/vesselschedule/searchschedule/SearchScheduleTranslationText'
import useBreadcrumbNameMap from 'src/navigations/breadcrumbs/Breadcrumb_VesselSchedule'

function ManagePreferredCarrierTablePage(props) {
  const translatedTextsObject = TranslationText()
  const breadcrumbNameMap = useBreadcrumbNameMap()

  return (
    <CngBasePage
      moduleTitle={translatedTextsObject.vesselSchedule}
      renderPage={(showSnackbar) => (
        <ManagePreferredCarrierTable
          showNotification={showSnackbar}
          {...props}
        />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export { ManagePreferredCarrierTablePage }
